/* eslint-disable unicorn/filename-case */
import { isNotNullOrWhiteSpace } from "Utils/String";
import { asType, assertSuccessStatus } from "./Request";

export async function getJSON<T>(url: string, showError = true): Promise<T> {
  const response = await fetch(url);
  await assertSuccessStatus(response);
  return asType<T>(response, showError);
}

export async function tryGetJSON<T>(url: string, infoMessage?: string): Promise<T> {
  try {
    const result = await getJSON<T>(url, false);
    return result;
  } catch {
    // ignore intentionally
    if (isNotNullOrWhiteSpace(infoMessage)) {
      // eslint-disable-next-line no-console
      console.info(`\t\t${infoMessage}\r\n\r\n`);
    }
    return Promise.resolve({} as T);
  }
}
